import Store from 'lightningjs-redux';
import { getCurrentRoute, isNavigationAllowed } from '../../logic/routing/routing.selectors';
import { getLayoutNavigation, getNavigationSection } from '../../logic/layout/layout.selectors';
import { isAppInitialized } from '../../logic/app/app.selectors';

const mapControllers = instance => [
  {
    selector: getNavigationSection,
    callback: value => {
      instance.section = value;
    },
  },
  {
    selector: isNavigationAllowed,
    callback: value => {
      instance.isActive = value;
    },
  },
  {
    selector: isAppInitialized,
    callback: value => {
      instance.couldRequestNavigationLayout = value;
    },
  },
  {
    selector: getLayoutNavigation,
    callback: value => {
      instance.navigation = value;
    },
  },
  {
    selector: getCurrentRoute,
    callback: value => {
      instance.currentRoute = value;
    },
  },
];

export default Store.control(mapControllers);
